import brand from '@helpers/brand';
import { cssVar } from '@helpers/cssVar';
import fonts from '@helpers/fonts';
import { Device, from } from '@helpers/media';
import svgChevronDown from '@img/icons/chevron-down.svg';
import svgChevronDownWhite from '@img/icons/chevron-down-white.svg';
import styled from 'styled-components';
const Container = styled.div `
  position: relative;
  display: block;
  width: auto;
`;
const Select = styled.select `
  display: block;
  appearance: none;
  background: transparent url('${svgChevronDown}') no-repeat;
  background-position: center right 12px;
  background-size: 16px 8px;
  border: 1px solid ${cssVar('fgColor')};
  border-radius: 9px;
  color: ${cssVar('fgColor')};
  ${fonts.sourceSansPro.regular};
  font-size: 16px;
  line-height: 20px;
  height: 48px;
  padding: 0 30px 0 12px;
  width: 100%;

  .theme-rss & {
    background: transparent url('${svgChevronDownWhite}') no-repeat;
    background-position: center right 12px;
    background-size: 16px 8px;

    option {
      background-color: ${cssVar('bgColor')};
      color: ${cssVar('fgColor')};
    }
  }

  @media ${from(Device.Desktop)} {
    background-position: center right 18px;
    font-size: 20px;
    line-height: 24px;
    padding: 0 42px 0 24px;
  }

  &:disabled {
    cursor: not-allowed;
    background-color: ${brand.white};
  }
`;
export const Icon = styled.span `
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  display: block;
  height: 20px;
  width: 20px;
  background-color: ${brand.white};

  @media ${from(Device.Tablet)} {
    height: 24px;
    width: 24px;
  }
`;
export default {
    Container,
    Icon,
    Select,
};
